import { ApiResponse, postRequest } from "@/data/apiClient";

export interface HistoricAccountUpdate {
  email: string;
}

export interface HistoricAccountUpdateResponse {
  response: any;
}

export const updateHistoricalAccount = async (
  data: HistoricAccountUpdate
): Promise<ApiResponse<HistoricAccountUpdateResponse>> =>
  postRequest("pendingUser/register", data);
